import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { DocsRecibidosManualmenteComponent } from './../compras/docs-recibidos-manualmente/docs-recibidos-manualmente.component';
import { ModalAgregarDocumentoComponent } from './../compras/docs-recibidos-manualmente/modal-agregar-documento/modal-agregar-documento/modal-agregar-documento.component';
import { ModalSeleccionarProductoProveedorComponent } from './docs-recibidos-manualmente/modal-seleccionar-producto/modal-seleccionar-producto/modal-seleccionar-producto-proveedor.component';
import { ModalSeleccionDocumentoFTComponent } from './common/modal-seleccion-documento-ft/modal-seleccion-documento.-ftcomponent';
import { NotaCreditoComprasComponent } from './../compras/recep-nota-credito/nota-credito.component';
import { ModalAnulacionDocComponent } from './../compras/recep-nota-credito/modal-anulacion-doc/modal-anulacion-doc.component';
import { ModalAgregarDocumentoNotaCreditoComponent } from './../compras/recep-nota-credito/modal-agregar-documento-nota-credito/modal-agregar-documento-nota-credito.component';
import { ModalObservacionesComponent } from './../compras/recep-nota-credito/modal-observaciones/modal-observaciones.component';
import { ModalSeleccionDocumentoComponent } from './../compras/recep-nota-credito/modal-seleccion-documento/modal-seleccion-documento.component';
import { NotaCreditoFTComponent } from './nota-credito/nota-credito.component';
import { NotaCreditoCabeceraFTComponent } from './nota-credito/nota-credito-cabecera/nota-credito-cabecera.component';
import { NotaCreditoDetallesFTComponent } from './nota-credito/nota-credito-detalles/nota-credito-detalles.component';
import { ModalObservacionesFTComponent } from './common/modal-observaciones/modal-observaciones-ft.component';

@NgModule({
  declarations: [
    DocsRecibidosManualmenteComponent,
    ModalAgregarDocumentoComponent,
    ModalSeleccionarProductoProveedorComponent,
    NotaCreditoComprasComponent,
    ModalAnulacionDocComponent,
    ModalAgregarDocumentoNotaCreditoComponent,
    ModalObservacionesComponent,
    ModalSeleccionDocumentoComponent,
    NotaCreditoFTComponent,
    NotaCreditoCabeceraFTComponent,
    NotaCreditoDetallesFTComponent,
    ModalSeleccionDocumentoFTComponent,
    ModalObservacionesFTComponent,
  ],
  imports: [CommonModule, ToastModule.forRoot(), MDBBootstrapModulesPro.forRoot(), Ng9RutModule, FormsModule, ReactiveFormsModule, SharedViewsModule, SharedModule],
  exports: [],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class ComprasModule {}
